export default {
  mainColor: "#0C3167",
  keyColor: "#31A0ED",
  attentionColor: "#FF6455",
  backgroundSkyblueColor: "#E8F4FF",
  backgroundGrayColor: "#F6F6F6",
}
